export class Address {
    StreetLines: any; 
    City: any; 
    PostalCode: any; 
    CountryCode: any;   
} 
 